module.exports = __webpack_public_path__ + "static/media/product.d2dc90d8.png";